__turbopack_context__.v({
  "addressLine1": "waODpa_addressLine1",
  "addressLine2": "waODpa_addressLine2",
  "businessInfo": "waODpa_businessInfo",
  "businessNumber": "waODpa_businessNumber",
  "column": "waODpa_column",
  "dataLine1": "waODpa_dataLine1",
  "dataLine2": "waODpa_dataLine2",
  "dataLines": "waODpa_dataLines",
  "dataLogo": "waODpa_dataLogo",
  "dataRow": "waODpa_dataRow",
  "distance": "waODpa_distance",
  "legalName": "waODpa_legalName",
  "restaurantAddress": "waODpa_restaurantAddress",
  "restaurantMap": "waODpa_restaurantMap",
  "restaurantMetaDataList": "waODpa_restaurantMetaDataList",
  "restaurantName": "waODpa_restaurantName",
});
